import type { Template } from "@/types";

export const LA_04_H1_V3: Template[] = [
{
    id: "la-04-h1v3-01",
    name: "LA 01 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 139, y: 0, width: 358, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 800, y: 54, width: 290, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 800, y: 236, width: 142, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 950, y: 236, width: 141, height: 185, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-02",
    name: "LA 02 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 88, y: 48, width: 269, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 48, width: 188, height: 115, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 169, width: 188, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 48, width: 291, height: 380, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-03",
    name: "LA 03 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 180, y: 48, width: 277, height: 381, rotation: 0, imageRotation: 0 },
            { id: "2", x: 806, y: 48, width: 294, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 806, y: 229, width: 144, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 957, y: 229, width: 143, height: 198, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-04",
    name: "LA 04 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 43, y: 108, width: 179, height: 260, rotation: 0, imageRotation: 0 },
            { id: "2", x: 230, y: 108, width: 178, height: 260, rotation: 0, imageRotation: 0 },
            { id: "3", x: 416, y: 108, width: 178, height: 260, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 48, width: 550, height: 380, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-05",
    name: "LA 05 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 98, y: 100, width: 441, height: 269, rotation: 0, imageRotation: 0 },
            { id: "2", x: 737, y: 38, width: 284, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1027, y: 38, width: 147, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1027, y: 243, width: 147, height: 197, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-06",
    name: "LA 06 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 172, y: 48, width: 143, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 172, y: 251, width: 293, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 48, width: 143, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 809, y: 48, width: 292, height: 378, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-07",
    name: "LA 07 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 113, y: 55, width: 264, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 384, y: 55, width: 134, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 384, y: 241, width: 134, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 55, width: 555, height: 368, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-08",
    name: "LA 08 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 55, width: 555, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 748, y: 55, width: 266, height: 368, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1021, y: 55, width: 132, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1021, y: 241, width: 132, height: 181, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-09",
    name: "LA 09 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 69, width: 222, height: 338, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 69, width: 222, height: 338, rotation: 0, imageRotation: 0 },
            { id: "3", x: 500, y: 69, width: 222, height: 338, rotation: 0, imageRotation: 0 },
            { id: "4", x: 730, y: 69, width: 502, height: 338, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-04-h1v3-10",
    name: "LA 10 - H1V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 69, width: 222, height: 338, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 69, width: 502, height: 338, rotation: 0, imageRotation: 0 },
            { id: "3", x: 780, y: 69, width: 222, height: 338, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1010, y: 69, width: 222, height: 338, rotation: 0, imageRotation: 0 }
    ],
}
];